import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpoReport from './ExpoReport/ExpoReport';
import StatsUpload from './StatsUpload/StatsUpload';
import CreditReport from './CreditReport/CreditReport';
import DatabaseChecker from './DatabaseChecker/DatabaseChecker';
// import UpdateUserForm from './UpdateUser/UpdateUserForm';
// import CreateUserForm from './CreateUser/CreateUserForm';
// import AdminPanelStyles from './styles';
// import './AdminPanel.css';

const ManagerPanel = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [tool, setTool] = React.useState('report');

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    if (newAlignment !== null) {
      setTool(newAlignment);
    }
  };

  return (
    <Box
      className="admin-panel"
      color={theme.brandcolor.primaryDark}
      sx={{ bgcolor: theme.brandcolor.primaryLight }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: '1em',
        }}
      >
        <Button
          variant="text"
          size="large"
          sx={{ color: 'black' }}
          onClick={() => {
            navigate('/home');
          }}
          startIcon={<ArrowBackIcon />}
        >
          Home
        </Button>
        <ToggleButtonGroup
          color="primary"
          value={tool}
          exclusive
          onChange={handleChange}
          size="large"
          sx={{ flexGrow: 1, justifyContent: 'center', display: 'flex' }}
        >
          <ToggleButton value="report">Expo Report Name</ToggleButton>
          <ToggleButton value="stat">Expo Stat File Update</ToggleButton>
          <ToggleButton value="credit_Report">Credit Report</ToggleButton>
          <ToggleButton value="database">Database Expo Check</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      {tool === 'report' && <ExpoReport />}
      {tool === 'stat' && <StatsUpload />}
      {tool === 'credit_Report' && <CreditReport />}
      {tool === 'database' && <DatabaseChecker />}
    </Box>
  );
};

export default ManagerPanel;
